import { useFormContentToggle } from "./form-content.hook";
import { useCruiseContext } from "../../provider/cruise.provider";
import OptionSelection from "../option-section";

export default function FormContent() {
  const { setSelectedAnswer, magnoliaData } = useCruiseContext();
  const { handleClick, toggleButtonOptions } =
    useFormContentToggle(setSelectedAnswer);
  const { questionText } = magnoliaData.overlayArea[0];

  return (
    <div className="w-full flex justify-center">
      <div className="lg:w-[414px] md:w-[400px] w-full ">
        <h1
          className=" font-header-font lg:text-[39px] md:text-3xl text-[26px] lg:leading-[44.85px] 
          md:leading-[34.1px] leading-[29.9px] text-text-title md:text-left text-center"
        >
          {questionText}
        </h1>
        <OptionSelection
          options={toggleButtonOptions}
          onOptionSelect={(id) => {
            handleClick(id);
          }}
        />
      </div>
    </div>
  );
}
